export function Url(url = "") {

    if(!url) {
        return url;
    }


    if(url.includes("https://") || url.includes("http://")) {
        return url;
    }


    return `https://${url}`
}